'use strict';

var React = require('react');

var SvgBarcodeMajor = function SvgBarcodeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h1v-2h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5h2v-1zm14 0v1h2v-1.5a1.5 1.5 0 0 0-1.5-1.5h-1.5v2h1zm-1 14h1v-1h2v1.5a1.5 1.5 0 0 1-1.5 1.5h-1.5v-2zm-13 0v-1h-2v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5v-2h-1zm-1-3h3v-8h-3v8zm12 0h-3v-8h3v8zm-7 0h2v-8h-2v8zm9 0h2v-8h-2v8z"
  }));
};

exports.SvgBarcodeMajor = SvgBarcodeMajor;
